import { useEffect } from 'react';
import I18n from 'I18n';
export const setTitle = title => {
  document.title = I18n.text(`pricingPage.windowTitles.${title}`);
};
export const resetTitle = () => {
  setTitle('default');
};
export const useDocumentTitle = title => {
  useEffect(() => {
    setTitle(title);
    return () => resetTitle();
  }, [title]);
};